import GlobalData from "../GlobalData";
import { useAuthenticationStore } from "@/stores/authentication";
import AuditLogView from "@/views/AuditLog/AuditLogView.vue";
import ContentView from "@/views/ContentReview/ContentView.vue";
import SipView from "@/views/ContentReview/sub/SipView.vue";
import TransferReportView from "@/views/ContentReview/sub/TransferReportView.vue";
import DownloadDipsView from "@/views/DownloadDips/DownloadDipsView.vue";
import DownloadReportView from "@/views/DownloadReport/DownloadReportView.vue";
import LoginCallback from "@/views/Login/LoginCallback.vue";
import LoginView from "@/views/Login/LoginView.vue";
import ProgessView from "@/views/Progress.vue";
import BatchesProcessedView from "@/views/Report1/BatchesProcessedView.vue";
import ErrorPage from "@/views/errorPage/ErrorPage.vue";
import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
  history: createWebHistory("/"),
  routes: [
    { path: "/", redirect: "/content" },
    {
      path: "/login",
      name: "login",
      component: LoginView,
      meta: {
        hasError: true,
        requiresUnauth: true,
        hasPermission: [0, 1, 2, 3, 4, 5],
      },
    },
    {
      path: "/login-callback",
      name: "login-callback",
      component: LoginCallback,
      meta: {
        hasError: true,
        requiresUnauth: true,
        hasPermission: [0, 1, 2, 3, 4, 5],
      },
    },
    {
      path: "/content",
      name: "content",
      component: ContentView,
      meta: {
        hasError: true,
        breadcrumb: [{ name: "Content Review" }],
        hasPermission: [0, 2, 3, 5],
      },
    },
    {
      path: "/content/sip/:selectedTransferId",
      name: "sip",
      component: SipView,
      meta: {
        hasError: true,
        hasPermission: [0, 2, 3, 5],
        breadcrumb: [{ name: "Content Review" }, { name: "SIP Details" }],
      },
      props: { default: true },
    },
    {
      path: "/content/transfer_report/:selectedTransferId",
      name: "transferreport",
      component: TransferReportView,
      meta: {
        hasError: true,
        hasPermission: [0, 1, 2, 3, 5],
        breadcrumb: [
          { name: "Content Review" },
          { name: "Transfer Processing Report" },
        ],
      },
      props: { default: true },
    },
    {
      path: "/downloadreport",
      name: "downloadreport",
      component: DownloadReportView,
      meta: {
        hasError: true,
        hasPermission: [0, 2, 3, 5],
        breadcrumb: [
          { name: "Manage Transfers" },
          { name: "Download Reports" },
        ],
      },
    },
    {
      path: "/downloaddips",
      name: "downloaddips",
      component: DownloadDipsView,
      meta: {
        hasError: true,
        hasPermission: [0,2, 3, 4, 5],
        breadcrumb: [{ name: "Manage Transfers" }, { name: "Download DIPs" }],
      },
    },
    {
      path: "/batchesprocessed",
      name: "batchesprocessed",
      component: ProgessView,
      meta: {
        hasError: true,
        hasPermission: [0, 2, 3, 5],
        breadcrumb: [
          { name: "Manage Reports" },
          { name: "Report: Batches Processed" },
        ],
      },
    },
    {
      path: "/auditlog",
      name: "auditlog",
      component: AuditLogView,
      meta: {
        hasError: true,
        hasPermission: [2, 3, 5],
        breadcrumb: [{ name: "Administration" }, { name: "Audit Log" }],
      },
    },
    {
      path: "/admin",
      name: "admin",
      component: ProgessView,
      meta: {
        hasError: true,
        hasPermission: [0, 1, 5],
        breadcrumb: [{ name: "Administration" }],
      },
    },
    {
      path: "/error",
      name: "error",
      component: ErrorPage,
      meta: {
        hasPermission: [0, 1, 2, 3, 4, 5],
        hasError: true,
      },
      beforeEnter: (_, from) => {
        if (from.meta.hasError || GlobalData.getInstance().canAccessError) {
          return true;
        } else {
          return { name: "content" };
        }
      },
    },
    {
      path: "/:notFound(.*)",
      name: "notfound",
      component: ErrorPage,
      meta: {
        breadcrumb: [],
        hasPermission: [0, 1, 2, 3, 4, 5],
        hasError: true,
      },
    },
  ],
  strict: false,
});

router.beforeEach((to, _, next) => {
  const authenticationStore = useAuthenticationStore();
  const publicRoutes: Array<string | undefined> = [
    "login",
    "login-callback",
    "error",
  ];

  if (GlobalData.getInstance().hasErrorPage == true) {
    GlobalData.getInstance().hasErrorPage = false;
    next({ name: "error" });
    return;
  }

  const permissionArray: Array<number> = to.meta.hasPermission as Array<number>;
  if (
    !authenticationStore.isUserValid &&
    !publicRoutes.includes(to.name?.toString())
  ) {
    next({ name: "login" });
  } else if (authenticationStore.isUserValid && to.meta.requiresUnauth) {
    next({ name: "content" });
  } else if (!permissionArray.includes(authenticationStore.userRole)) {
    GlobalData.getInstance().errorMessage.setErrorStatus(403);
    GlobalData.getInstance().hasErrorPage = false;
    GlobalData.getInstance().canAccessError = true;
    next({ name: "error" });
  } else {
    next();
  }
});

export default router;
